/* angular */
import { createAction, props } from '@ngrx/store';

/* payloads */
import {
  GetTourClientsByTourIdActionPayload,
  GetTourClientsByTourIdSuccessfulActionPayload,
  SendTourApprovalEmailToTourClientsActionPayload,
  GetToursSuccessfulActionPayload,
  GetTourByIdActionPayload,
  GetTourByIdSuccessfulActionPayload,
  GetActiveTourWithRelationsByIdActionPayload,
  GetActiveTourByIdWithRelationsSuccessfulActionPayload,
  CreateTourActionPayload,
  CreateTourSuccessfulActionPayload,
  UpdateTourActionPayload,
  UpdateTourSuccessfulActionPayload,
  DeleteTourActionPayload,
  DeleteTourSuccessfulActionPayload,
} from 'src/app/features/shared/models/event/tour-data-store';

/* action types */
export enum ActionTypes {
  GetTourClientsByTourId = '[TOUR] GetTourClientsByTourId',
  GetTourClientsByTourIdSuccessful = '[TOUR] GetTourClientsByTourIdSuccessful',
  GetTourClientsByTourIdFailure = '[TOUR] GetTourClientsByTourIdFailure',
  SendTourApprovalEmailToTourClients = '[TOUR] SendTourApprovalEmailToTourClients',
  SendTourApprovalEmailToTourClientsSuccessful = '[TOUR] SendTourApprovalEmailToTourClientsSuccessful',
  SendTourApprovalEmailToTourClientsFailure = '[TOUR] SendTourApprovalEmailToTourClientsFailure',
  InitFetchingActiveTourWithRelations = '[TOUR] InitFetchingActiveTourWithRelations',
  GetTours = '[TOUR] GetTours',
  GetToursSuccessful = '[TOUR] GetToursSuccessful',
  GetToursFailure = '[TOUR] GetToursFailure',
  GetTourById = '[TOUR] GetTourById',
  GetTourByIdSuccessful = '[TOUR] GetTourByIdSuccessful',
  GetTourByIdFailure = '[TOUR] GetTourByIdFailure',
  GetActiveTourWithRelationsById = '[TOUR] GetActiveTourWithRelationsById',
  GetActiveTourByIdWithRelationsSuccessful = '[TOUR] GetActiveTourByIdWithRelationsSuccessful',
  GetActiveTourByIdWithRelationsFailure = '[TOUR] GetActiveTourByIdWithRelationsFailure',
  CreateTour = '[TOUR] CreateTour',
  CreateTourSuccessful = '[TOUR] CreateTourSuccessful',
  CreateTourFailure = '[TOUR] CreateTourFailure',
  UpdateTour = '[TOUR] UpdateTour',
  UpdateTourSuccessful = '[TOUR] UpdateTourSuccessful',
  UpdateTourFailure = '[TOUR] UpdateTourFailure',
  DeleteTour = '[TOUR] DeleteTour',
  DeleteTourSuccessful = '[TOUR] DeleteTourSuccessful',
  DeleteTourFailure = '[TOUR] DeleteTourFailure',
  ResetState = '[TOUR] ResetState',
}

/* actions */

export const GetTourClientsByTourId = createAction(
  ActionTypes.GetTourClientsByTourId,
  props<{ payload: GetTourClientsByTourIdActionPayload }>(),
);

export const GetTourClientsByTourIdSuccessful = createAction(
  ActionTypes.GetTourClientsByTourIdSuccessful,
  props<{ payload: GetTourClientsByTourIdSuccessfulActionPayload }>(),
);

export const GetTourClientsByTourIdFailure = createAction(
  ActionTypes.GetTourClientsByTourIdFailure,
);

export const SendTourApprovalEmailToTourClients = createAction(
  ActionTypes.SendTourApprovalEmailToTourClients,
  props<{ payload: SendTourApprovalEmailToTourClientsActionPayload }>(),
);

export const SendTourApprovalEmailToTourClientsSuccessful = createAction(
  ActionTypes.SendTourApprovalEmailToTourClientsSuccessful,
);

export const SendTourApprovalEmailToTourClientsFailure = createAction(
  ActionTypes.SendTourApprovalEmailToTourClientsFailure,
);

export const InitFetchingActiveTourWithRelations = createAction(
  ActionTypes.InitFetchingActiveTourWithRelations,
);

/* This event gets the all Tours. */
export const GetTours = createAction(ActionTypes.GetTours);

/* This event is fired after getting all the Tours successfully. */
export const GetToursSuccessful = createAction(
  ActionTypes.GetToursSuccessful,
  props<{ payload: GetToursSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't get all the Tours. */
export const GetToursFailure = createAction(ActionTypes.GetToursFailure);

/* This event gets the Tour by Tour id. */
export const GetTourById = createAction(
  ActionTypes.GetTourById,
  props<{ payload: GetTourByIdActionPayload }>(),
);

/* This event is fired after getting Tour by Tour id successfully. */
export const GetTourByIdSuccessful = createAction(
  ActionTypes.GetTourByIdSuccessful,
  props<{ payload: GetTourByIdSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't get the Tour by Tour id. */
export const GetTourByIdFailure = createAction(ActionTypes.GetTourByIdFailure);

/* This event gets the active Tour by Tour id. */
export const GetActiveTourWithRelationsById = createAction(
  ActionTypes.GetActiveTourWithRelationsById,
  props<{ payload: GetActiveTourWithRelationsByIdActionPayload }>(),
);

/* This event is fired after getting Tour by Tour id successfully. */
export const GetActiveTourByIdWithRelationsSuccessful = createAction(
  ActionTypes.GetActiveTourByIdWithRelationsSuccessful,
  props<{ payload: GetActiveTourByIdWithRelationsSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't get the Tour by Tour id. */
export const GetActiveTourByIdWithRelationsFailure = createAction(
  ActionTypes.GetActiveTourByIdWithRelationsFailure,
);

/* This event creates a Tour. */
export const CreateTour = createAction(
  ActionTypes.CreateTour,
  props<{ payload: CreateTourActionPayload }>(),
);

/* This event is fired after creating a Tour successfully. */
export const CreateTourSuccessful = createAction(
  ActionTypes.CreateTourSuccessful,
  props<{ payload: CreateTourSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't create a Tour successfully. */
export const CreateTourFailure = createAction(ActionTypes.CreateTourFailure);

/* This event updates a Tour. */
export const UpdateTour = createAction(
  ActionTypes.UpdateTour,
  props<{ payload: UpdateTourActionPayload }>(),
);

/* This event is fired after updating a Tour successfully. */
export const UpdateTourSuccessful = createAction(
  ActionTypes.UpdateTourSuccessful,
  props<{ payload: UpdateTourSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't update a Tour successfully. */
export const UpdateTourFailure = createAction(ActionTypes.UpdateTourFailure);

/* This event deletes a Tour. */
export const DeleteTour = createAction(
  ActionTypes.DeleteTour,
  props<{ payload: DeleteTourActionPayload }>(),
);

/* This event is fired after deleting a Tour successfully. */
export const DeleteTourSuccessful = createAction(
  ActionTypes.DeleteTourSuccessful,
  props<{ payload: DeleteTourSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't delete a Tour successfully. */
export const DeleteTourFailure = createAction(ActionTypes.DeleteTourFailure);

/* This event resets the Tour state. */
export const ResetState = createAction(ActionTypes.ResetState);
